import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDataCatalogLineageFlowWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      d="M12 11h7c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-7c-.6 0-1 .4-1 1v2H9c-.3-1.7-1.7-3-3.5-3C3.6 4 2 5.6 2 7.5S3.6 11 5.5 11c.3 0 .6 0 .8-.1l4.7 5.6V19c0 .6.4 1 1 1h7c.6 0 1-.4 1-1v-5c0-.6-.4-1-1-1h-7c-.6 0-1 .4-1 1v.9l-3.7-4.4C8.2 10 8.8 9.1 9 8h2v2c0 .6.4 1 1 1zm7-6v5h-7V5h7zm0 9v5h-7v-5h7zM5.5 10C4.1 10 3 8.9 3 7.5S4.1 5 5.5 5 8 6.1 8 7.5 6.9 10 5.5 10z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
const Memo = memo(SvgDataCatalogLineageFlowWhite);
export default Memo;
